/**
 * Coverage A / E floors the CFM farm post-data rules raise a limit to, shared with the CFM GO importer,
 * which marks a GO limit below one of them as underwriter-approved (the #35617 limit override) rather
 * than letting it be raised. One definition, so the importer flags exactly the limits the rules would
 * otherwise move. #36956
 */

/**
 * #35617: the hard floor of an underwriter-overridden Coverage A / E limit — any value at or above it,
 * no cap. Matches staff-fe's COVERAGE_LIMIT_OVERRIDE_FLOOR. A limit below it can't be represented as
 * an override: the rules would raise it to this floor.
 */
export const COVERAGE_LIMIT_OVERRIDE_FLOOR = 1000;

/** Coverage A floor for a dwelling when the brand's farm state config sets no `minimumDwellingCoverageA` (#28995). */
export const DEFAULT_MINIMUM_DWELLING_COVERAGE_A = 75000;

/** FO-6 structure Coverage E floor for building class 1 (#28960). */
export const CLASS_1_STRUCTURE_MINIMUM_COVERAGE_E = 7500;

/** FO-6 structure Coverage E floor for every other building class, or none (#28960). */
export const STRUCTURE_MINIMUM_COVERAGE_E = 1000;

/** The dwelling Coverage A floor for a farm location's state, from the brand's farm state config. */
export function minimumDwellingCoverageA(
  stateConfig: { minimumDwellingCoverageA?: number | null } | null | undefined
): number {
  return stateConfig?.minimumDwellingCoverageA ?? DEFAULT_MINIMUM_DWELLING_COVERAGE_A;
}

/** The FO-6 structure Coverage E floor for a building class. */
export function minimumStructureCoverageE(buildingClass: number | null | undefined): number {
  return buildingClass === 1 ? CLASS_1_STRUCTURE_MINIMUM_COVERAGE_E : STRUCTURE_MINIMUM_COVERAGE_E;
}
